// Types
import type { Action } from "./types";

/**
 * @desc update a company contact or plan administrator
 * @param {*} data axios request params
 * @return {*}  {Action}
 */
export const updateCompanyContact = (data: any): Action => ({
  type: "UPDATE_COMPANY_CONTACT",
  data,
});
